module.exports = __webpack_public_path__ + "static/img/img-qc.eb656bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-qc.png
// module id = jDSf
// module chunks = 1